import React, { useEffect, useState, useCallback } from "react";
import axiosInstance from "../../axiosInstance";
import Container from "react-bootstrap/Container";
import Alert from "react-bootstrap/Alert";
import Form from "react-bootstrap/Form";
import DataTable from "react-data-table-component";
import "bootstrap/dist/css/bootstrap.min.css";
import "./MemberList.css";
import ThinFooter from "../Footer/ThinFooter"; // Import the footer component

const MemberList = () => {
    const [members, setMembers] = useState([]);
    const [totalMembers, setTotalMembers] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(-1); // ✅ Set initial value to "All"
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");

    const fetchMembers = useCallback(async (page = 1, rowsPerPage = totalMembers) => {
        const token = localStorage.getItem("token");

        if (!token) {
            setError("Unauthorized: No token found.");
            return;
        }

        try {
            const response = await axiosInstance.get(`/users/listMembers?page=${page}&limit=${rowsPerPage}`, {
                headers: {
                    Authorization: token,
                },
            });

            if (response.data.success && response.data.data) {
                setMembers(response.data.data.members);
                setTotalMembers(response.data.data.meta.totalMembers);
                setCurrentPage(parseInt(response.data.data.meta.currentPage, 10));
            } else {
                setError("Failed to fetch members or no data found.");
            }
        } catch (err) {
            setError("An error occurred while fetching members.");
        }
    }, [totalMembers]);

    useEffect(() => {
        fetchMembers(currentPage, perPage === -1 ? totalMembers : perPage);
    }, [fetchMembers, currentPage, perPage]);

const filteredMembers = members.filter(member => {
    const fullName = `${member.firstName} ${member.lastName}`.toLowerCase();
    const email = member.email?.toLowerCase() || "";
    const phone = member.phone?.toLowerCase() || "";
    const id = member.id ? String(member.id).toLowerCase() : "";

    // Split search term into individual words
    const searchWords = searchTerm.toLowerCase().trim().split(/\s+/);

    // Ensure all words are found in at least one of the fields
    return searchWords.every(word => 
        fullName.includes(word) || email.includes(word) || phone.includes(word) || id.includes(word)
    );
});


    const columns = [
        {
            name: "ID",
            selector: row => `${row.firstName}_${row.lastName}_${row.id}`,
            sortable: true,
            minWidth: "200px",
        },
        {
            name: "Name",
            selector: row => `${row.firstName} ${row.lastName}`,
            sortable: true,
            minWidth: "200px",
        },
        {
            name: "Email",
            selector: row => row.email,
            sortable: true,
            minWidth: "300px",
        },
        {
            name: "Phone",
            selector: row => row.phone || "N/A",
            sortable: true,
            minWidth: "200px",
        },
    ];

    return (
        <>
            <Container fluid className="p-3 d-flex justify-content-center">
                <div style={{ width: "80%", marginLeft: "240px" }}>
                    <h2 className="text-center mb-4">Members List</h2>
                    {error && <Alert variant="danger" className="text-center">{error}</Alert>}

                    <Form.Control
                        type="text"
                        placeholder="Search Members..."
                        className="mb-3 smm"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />

                    <DataTable
                        columns={columns}
                        data={filteredMembers}
                        pagination
                        paginationServer
                        paginationTotalRows={totalMembers}
                        paginationPerPage={totalMembers} // ✅ Default to "All"
                        paginationDefaultPage={currentPage}
                        paginationRowsPerPageOptions={[totalMembers, 10, 15, 20, 25, 30]} // ✅ "All" at the top
                        onChangePage={(page) => {
                            setCurrentPage(page);
                            fetchMembers(page, perPage);
                        }}
                        onChangeRowsPerPage={(newPerPage, page) => {
                            const updatedPerPage = newPerPage === totalMembers ? totalMembers : newPerPage;
                            setPerPage(updatedPerPage);
                            fetchMembers(page, updatedPerPage);
                        }}
                        paginationComponentOptions={{
                            noRowsPerPage: false,
                            rangeSeparatorText: "of",
                            rowsPerPageText: "Records per page:",
                            selectAllRowsItem: true,
                            selectAllRowsItemText: "All",
                            selectAllRowsItemValue: totalMembers, // ✅ Ensures "All" is recognized
                            previousLabel: "Previous",
                            nextLabel: "Next",
                        }}
                        highlightOnHover
                        responsive
                        striped
                        fixedHeader
                        fixedHeaderScrollHeight="500px"
                        noDataComponent="No members found."
                        customStyles={{
                            table: { style: { width: "100%" } },
                            rows: { style: { fontSize: "16px", padding: "12px" } },
                            headCells: { style: { backgroundColor: "#f8f9fa", fontWeight: "bold", fontSize: "18px" } },
                        }}
                    />
                </div>
            </Container>
            <ThinFooter /> {/* Add Footer here */}
        </>
    );
};

export default MemberList;
